import { useQuery } from "@tanstack/react-query";
import { apiRelProdutores } from "pages/relatorios/api/apiRelProdutores";
import { RelatorioContainer } from "pages/relatorios/components/RelatorioContainer";
import { useRelatorioStore } from "pages/relatorios/store";
import type { ApiRelatorioGetParams } from "pages/relatorios/types/ApiRelatorioParams";
import { buildRelatorioGetParams } from "pages/relatorios/utils/buildRelatorioGetParams";
import { useEffect, useMemo } from "react";
import { FilterBar } from "./FilterBar";
import { TableRelCadastroProdutor } from "./TableRelCadastroProdutor";

export function RelatorioCadastroProdutor() {
	const filter = useRelatorioStore((s) => s.filter);

	const limparFiltros = useRelatorioStore((s) => s.limparFiltros);

	const params: ApiRelatorioGetParams = useMemo(() => buildRelatorioGetParams(filter), [filter]);

	const { data, isFetching, refetch } = useQuery({
		queryKey: ["apiRelProdutores", params],
		queryFn: () => apiRelProdutores({ params }),
		enabled: false,
	});

	const registros = useMemo(() => data?.registros || [], [data]);

	useEffect(() => {
		limparFiltros();
	}, [limparFiltros]);

	const title = "Dados cadastrais do produtor";

	return (
		<RelatorioContainer
			breadCrumbs={["Relatórios", "Produtor"]}
			refetch={refetch}
			filterBar={<FilterBar />}
			loading={isFetching}
			title={title}
			registros={registros}
			table={<TableRelCadastroProdutor data={data?.registros} title={title} />}
		/>
	);
}
